/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Disabled_Quick_SaleInputs */

const vi_order_recreate_disabled_quick_sale = /** @type {(inputs: Order_Recreate_Disabled_Quick_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn bán ngay tại quầy — không tạo lại được`)
};

/**

* @param {Order_Recreate_Disabled_Quick_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_disabled_quick_sale = /** @type {((inputs?: Order_Recreate_Disabled_Quick_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Disabled_Quick_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_disabled_quick_sale(inputs)
});